(function() {
  const root = document.getElementById('rn-faq-root');
  if (!root) return;

  var FAQ_CAT_IDS = ['orders','shipping','returns','sizing','sizeguide','brands','sustainability','payments'];
  var FAQ_RELOCATABLE_IDS = ['sizeguide','brands','sustainability','payments'];

  function allCategoryPanels() {
    return FAQ_CAT_IDS.map(function (id) { return document.getElementById('cat-' + id); }).filter(Boolean);
  }

  function repairFaqPanels() {
    var main = root.querySelector('.faq-main');
    if (!main) return;
    FAQ_RELOCATABLE_IDS.forEach(function (id) {
      var panel = document.getElementById('cat-' + id);
      if (panel && panel.parentElement !== main) main.appendChild(panel);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  onReady(repairFaqPanels);

  window.showCat = function(id, btn) {
    allCategoryPanels().forEach(function (c) { c.classList.remove('active'); });
    root.querySelectorAll('.cat-btn').forEach(function (b) { b.classList.remove('active'); });
    var cat = document.getElementById('cat-' + id);
    if (cat) cat.classList.add('active');
    if (btn) btn.classList.add('active');
  };

  window.toggleFaq = function(el) {
    var item = el.parentElement;
    var isOpen = item.classList.contains('open');
    allCategoryPanels().forEach(function (panel) {
      panel.querySelectorAll('.faq-item.open').forEach(function (i) { i.classList.remove('open'); });
    });
    if (!isOpen) item.classList.add('open');
  };

  window.showSizeTab = function(id, btn) {
    var sg = document.getElementById('cat-sizeguide');
    if (!sg) return;
    sg.querySelectorAll('.size-table-wrap').forEach(function (t) { t.classList.remove('active'); });
    sg.querySelectorAll('.size-tab').forEach(function (b) { b.classList.remove('active'); });
    var tab = document.getElementById('sizetab-' + id);
    if (tab) tab.classList.add('active');
    if (btn) btn.classList.add('active');
  };
})();
